import { Link } from '@grubhubprod/gh-cookbook-react';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useParams } from 'react-router-dom';
import { getNotFoundMessage } from 'src/components/oneCorp/features/MealCredit/common/formFields/SelectSearch/getNotFoundMessage';
import { SelectSearch } from 'src/components/SelectSearch/SelectSearch';
import { IGroup, useGroupSearch } from 'src/utilities/useSearchHooks';
import { LocTagInvite } from 'src/types/LineOfCredit';
import { filterGroupSearchResultsCb } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface GroupSelectSearchProps {
  name: keyof IGroup;
  tagInvites: LocTagInvite[];
  initGroup?: LocTagInvite;
}

export function GroupSelectSearch({
  name: keyName,
  tagInvites,
  initGroup = null,
}: GroupSelectSearchProps): JSX.Element {
  const { setValue, register } = useFormContext();

  const { corpid: corpId } = useParams<{ corpid: string }>();

  useEffect(() => {
    register(keyName, {
      required: true,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyName]);

  useEffect(() => {
    if (initGroup) {
      setValue(keyName, initGroup[keyName], {
        shouldValidate: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initGroup, keyName]);

  function noGroupsFoundCb(query: string): JSX.Element {
    const message = getNotFoundMessage(query, 'group');
    return (
      <>
        {message}Need to add a new group? Go to the{' '}
        <Link target="_blank" href={`/corporate/enterprise/${corpId}/groups/`}>
          Groups page
        </Link>{' '}
        and assign employees.
      </>
    );
  }

  return (
    <SelectSearch<IGroup, false>
      corpId={corpId as string}
      maxHeight="200px"
      displayProp="name"
      keyName={keyName}
      placeholder="Select a group"
      initialSelectedValue={initGroup}
      searchResource={useGroupSearch}
      onValueChange={(newGroup: IGroup) => {
        setValue(keyName, newGroup[keyName], {
          shouldValidate: true,
        });
        setValue('name', newGroup.name);
      }}
      inputSize="small"
      filterSearchResults={(group) =>
        filterGroupSearchResultsCb(group, tagInvites, initGroup)
      }
      getNoResultsMessage={noGroupsFoundCb}
    />
  );
}
